import React, {Component} from 'react';
import {Switch, Route} from 'react-router-dom';
import cx from 'classnames';
import {Home} from 'components/Home';
import {Team} from 'components/Team';
import {History} from 'components/History';
import {Resources} from 'components/Resources';
import {Files} from 'components/Files';
import {Contact} from 'components/Contact';
import {Header} from 'components/Header';
import {Footer} from 'components/Footer';
import {MobileNav} from 'components/MobileMenu';
import {
    InitialProject as InitialProject,
    InitialProjectContext
} from 'components/InitialProject';
import ScrollToTopOnMount from './ScrollToTopOnMount'
import style from './App.css';

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {
            openPopup: false,
            openMenu: false
        };
    }

    handleTogglePopup = () => {
        this.setState({
            openPopup: !this.state.openPopup
        });
    };

    handleToggleMenu = () => {
        this.setState({
            openMenu: !this.state.openMenu
        });
    };

    render() {
        const {openPopup, openMenu} = this.state;

        return (
            <div className={cx(style.root)}>
                <ScrollToTopOnMount/>
                <InitialProjectContext.Provider value={this.handleTogglePopup}>
                    <MobileNav
                        show={openMenu}
                        onClose={this.handleToggleMenu}
                    />

                    <Header
                        className={cx(style.header, {[style.disabledPointer]: openMenu || openPopup})}
                        onOpenMenu={this.handleToggleMenu}
                    />

                    {openPopup && <InitialProject onClose={this.handleTogglePopup}/>}

                    <main property="mainEntity" className={cx(style.content)}>
                        <Switch>
                            <Route exact path='/' component={Home}/>
                            <Route exact path='/history' component={History}/>
                            <Route path='/team' component={Team}/>
                            <Route path='/resources' component={Resources}/>
                            <Route path='/files' component={Files}/>
                            <Route path='/contact' component={Contact}/>
                        </Switch>
                    </main>
                    <Footer/>
                </InitialProjectContext.Provider>
            </div>
        );
    }
}

export default App;